import { AdvanceFilter } from '@/types/types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FilterStore {
  serviceFilters: AdvanceFilter[];
  setServiceFilters: (filters: AdvanceFilter[]) => void;
  serviceFiltersUserId: string | null;
  initServiceFilters: (userId: string, defaults: AdvanceFilter[]) => void;
  deliveryFilters: AdvanceFilter[];
  setDeliveryFilters: (filters: AdvanceFilter[]) => void;
  hiFilters: AdvanceFilter[];
  setHIFilters: (filters: AdvanceFilter[]) => void;
  hiFiltersUserId: string | null;
  initHIFilters: (userId: string, defaults: AdvanceFilter[]) => void;
  ddiFilters: AdvanceFilter[];
  setDDIFilters: (filters: AdvanceFilter[]) => void;
  reset: () => void;
}

// Defaults are applied once per user per list; afterwards saved filters (even empty) are kept as-is.
export const useFilterStore = create<FilterStore>()(
  persist(
    (set, get) => ({
      serviceFilters: [],
      setServiceFilters: (serviceFilters) => set({ serviceFilters }),
      serviceFiltersUserId: null,
      initServiceFilters: (userId, defaults) => {
        if (get().serviceFiltersUserId === userId) return;
        set({ serviceFilters: defaults, serviceFiltersUserId: userId });
      },
      deliveryFilters: [],
      setDeliveryFilters: (deliveryFilters) => set({ deliveryFilters }),
      hiFilters: [],
      setHIFilters: (hiFilters) => set({ hiFilters }),
      hiFiltersUserId: null,
      initHIFilters: (userId, defaults) => {
        if (get().hiFiltersUserId === userId) return;
        set({ hiFilters: defaults, hiFiltersUserId: userId });
      },
      ddiFilters: [],
      setDDIFilters: (ddiFilters) => set({ ddiFilters }),
      reset: () =>
        set({
          serviceFilters: [],
          serviceFiltersUserId: null,
          deliveryFilters: [],
          hiFilters: [],
          hiFiltersUserId: null,
          ddiFilters: [],
        }),
    }),
    {
      name: 'filter-store',
      partialize: (state) => ({
        serviceFilters: state.serviceFilters,
        serviceFiltersUserId: state.serviceFiltersUserId,
        deliveryFilters: state.deliveryFilters,
        hiFilters: state.hiFilters,
        hiFiltersUserId: state.hiFiltersUserId,
        ddiFilters: state.ddiFilters,
      }),
    }
  )
);
